import { FC } from 'react';

import { NAVIGATION_HEIGHT, NAVIGATION_MAIN_BAR_HEIGHT } from '../../constants';
import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { Skeleton } from './NavigationSkeleton.styles';

export const NavigationSkeleton: FC = () => {
    return (
        <Skeleton
            data-test={NAVIGATION_TEST_IDS.SKELETON}
            $height={NAVIGATION_HEIGHT}
            $heightMobile={NAVIGATION_MAIN_BAR_HEIGHT}
        />
    );
};
